var components
try {
  components = {
    previewProduct: function () {
      return import(
        /* webpackChunkName: "components/previewProduct/previewProduct" */ "@/components/previewProduct/previewProduct.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var m2 = _vm.topBarHeight()
  var m3 = !(m2 == 0) ? _vm.topBarHeight() : null
  var m4 = !(m2 == 0) ? _vm.topBarTop() : null
  var m5 = _vm.topBarHeight()
  var m6 = !(m5 == 0) ? _vm.topBarHeight() : null
  var m7 = !_vm.loadding ? _vm.topBarTop() : null
  var m8 =
    !_vm.loadding && _vm.ispresale && _vm.activeName == "advance"
      ? _vm.subPrice(
          _vm.detail[_vm.activeName][_vm.skuName][0].product_price,
          "1"
        )
      : null
  var m9 =
    !_vm.loadding && _vm.ispresale && _vm.activeName == "advance"
      ? _vm.subPrice(
          _vm.detail[_vm.activeName][_vm.skuName][0].product_price,
          "2"
        )
      : null
  var m10 =
    !_vm.loadding && _vm.ispresale && !(_vm.activeName == "advance")
      ? _vm.subPrice(
          _vm.detail[_vm.activeName][_vm.skuName][0][_vm.activePrice],
          "1"
        )
      : null
  var m11 =
    !_vm.loadding && _vm.ispresale && !(_vm.activeName == "advance")
      ? _vm.subPrice(
          _vm.detail[_vm.activeName][_vm.skuName][0][_vm.activePrice],
          "2"
        )
      : null
  var g0 =
    !_vm.loadding && _vm.ispresale && _vm.activeName == "advance"
      ? (
          _vm.detail[_vm.activeName][_vm.skuName][0].product_price * 1 -
          _vm.detail[_vm.activeName][_vm.skuName][0][_vm.activePrice] * 1
        ).toFixed(2)
      : null
  var a0 =
    !_vm.loadding && _vm.ispresale
      ? {
          startstamp: _vm.detail[_vm.activeName].start_time,
          endstamp: _vm.detail[_vm.activeName].end_time,
        }
      : null
  var g1 =
    !_vm.loadding && _vm.ispresale && _vm.activeName == "advance"
      ? (
          _vm.detail[_vm.activeName][_vm.skuName][0].product_price * 1 -
          _vm.detail[_vm.activeName][_vm.skuName][0][_vm.activePrice] * 1
        ).toFixed(2)
      : null
  var m12 =
    !_vm.loadding && _vm.show_discount && _vm.discount.give_points > 0
      ? _vm.points_name()
      : null
  var m13 =
    !_vm.loadding && _vm.show_discount && _vm.discount.give_points > 0
      ? _vm.points_name()
      : null
  var m14 =
    !_vm.loadding && _vm.show_discount && _vm.discount.give_points > 0
      ? _vm.points_name()
      : null
  var g2 =
    !_vm.loadding && _vm.show_discount
      ? _vm.discount.product_coupon.length
      : null
  var g3 =
    !_vm.loadding && _vm.show_discount
      ? _vm.discount.product_reduce.length
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.isVideoPlay = true
    }
    _vm.e1 = function ($event) {
      _vm.isVideoPlay = true
    }
    _vm.e2 = function ($event) {
      _vm.isVideoPlay = false
    }
    _vm.e3 = function ($event) {
      _vm.isVideoPlay = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        m5: m5,
        m6: m6,
        m7: m7,
        m8: m8,
        m9: m9,
        m10: m10,
        m11: m11,
        g0: g0,
        a0: a0,
        g1: g1,
        m12: m12,
        m13: m13,
        m14: m14,
        g2: g2,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }